module.exports = __webpack_public_path__ + "static/media/Green-Hydrogen-1.ea5713f7.jpeg";